import AddIcon from '@mui/icons-material/Add';
import Button, { type ButtonProps } from '@mui/material/Button';
import type React from 'react';
import type { ReactNode } from 'react';
import styles from './AddButtonStyles';

interface AddButtonProps extends Omit<ButtonProps, 'variant' | 'startIcon'> {
  children: ReactNode;
}

export default function AddButton({ children, ...rest }: AddButtonProps): React.ReactElement {
  const classes = styles();
  return (
    <Button variant="text" className={classes.button} startIcon={<AddIcon />} {...rest}>
      {children}
    </Button>
  );
}
